module.exports = __webpack_public_path__ + "static/media/benefit_placeholder_4.0bb009bc.png";